import { Box } from "@material-ui/core";
import React, { useCallback } from "react";
import AceEditor from "react-ace";
import useSignableDocumentsEditorStyles from "../hooks/useSignableDocumentsEditorStyles";
import { ViewMode } from "../utils/constants";
import { OPTIONS } from "../../../../../utils/htmlEditorConfig";

const ACE_EDITOR_PROPS = { $blockScrolling: true };

const SignableDocumentsEditorBody = React.memo(({
  value,
  handleAceChange,
  handleBlur,
  viewMode,
  disabled,
  editorRef,
  onEditorReady,
}) => {
  const classes = useSignableDocumentsEditorStyles();

  const handleLoad = useCallback((editor) => {
    const textarea = editor.textInput.getElement();
    if (textarea) {
      textarea.setAttribute("name", "html-editor");
      textarea.setAttribute("id", "html-editor");
    }
    if (onEditorReady) onEditorReady();
  }, [onEditorReady]);

  return (
    <Box
      className={classes.editorWrapper}
      style={{ display: viewMode === ViewMode.EDIT ? "block" : "none" }}
    >
      <AceEditor
        ref={editorRef}
        mode="html"
        theme="textmate"
        onChange={handleAceChange}
        value={value || ""}
        name="html-editor-container"
        editorProps={ACE_EDITOR_PROPS}
        setOptions={OPTIONS}
        width="100%"
        height="400px"
        fontSize={14}
        showPrintMargin={false}
        readOnly={disabled}
        placeholder="Enter Document Content"
        onBlur={handleBlur}
        onLoad={handleLoad}
      />
    </Box>
  );
});

export default SignableDocumentsEditorBody;
